<div class="power-bi-dashboard-container">
  @if (isLoading()) {
    <div class="loading-overlay">
      <app-loading-section />
    </div>
  }

  <iframe
    [title]="title()"
    [src]="sanitizedUrl()"
    allowFullScreen
    (load)="onIframeLoad()"
    [class.hidden]="isLoading()"
  ></iframe>
</div>
